import React, { useState } from 'react';
import '../styles/Blog.css';

const Blog = () => {
    const [activeCategory, setActiveCategory] = useState('all');

    const blogPosts = [
        {
            id: 1,
            title: 'How to Choose the Right Engine Oil for Your Vehicle',
            category: 'maintenance',
            date: '2024-01-15',
            author: 'MapLube Team',
            excerpt: 'Learn the essential factors to consider when selecting engine oil for optimal performance and engine protection.',
            content: 'Choosing the right engine oil is crucial for your vehicle\'s performance and longevity. Factors like viscosity grade, API rating, and your driving conditions all play important roles...',
            image: '/logo/engine_oil.jpeg',
            readTime: '5 min read'
        },
        {
            id: 2,
            title: 'The Future of Lubricants: Sustainable Solutions',
            category: 'industry',
            date: '2024-01-10',
            author: 'Dr. Priya Sharma',
            excerpt: 'Exploring the latest trends in eco-friendly lubricants and their impact on the automotive industry.',
            content: 'The lubricant industry is evolving rapidly with a focus on sustainability. New formulations are being developed to reduce environmental impact while maintaining performance...',
            image: '/logo/product.jpeg',
            readTime: '7 min read'
        },
        {
            id: 3,
            title: 'MapLube Launches New Premium Engine Oil Range',
            category: 'company',
            date: '2024-01-05',
            author: 'MapLube Marketing',
            excerpt: 'Introducing our latest premium engine oil formulations designed for modern vehicles and extreme conditions.',
            content: 'MapLube is excited to announce the launch of our new premium engine oil range. These advanced formulations provide superior protection and performance...',
            image: '/logo/map.jpeg',
            readTime: '3 min read'
        },
        {
            id: 4,
            title: 'Winter Maintenance Tips for Your Vehicle',
            category: 'maintenance',
            date: '2023-12-20',
            author: 'MapLube Team',
            excerpt: 'Essential maintenance tips to keep your vehicle running smoothly during winter months.',
            content: 'Winter weather can be harsh on your vehicle. Proper maintenance during cold months is essential for optimal performance and safety...',
            image: '/logo/map1.jpeg',
            readTime: '6 min read'
        },
        {
            id: 5,
            title: 'Understanding API Oil Classifications',
            category: 'education',
            date: '2023-12-15',
            author: 'Technical Team',
            excerpt: 'A comprehensive guide to understanding API oil classifications and what they mean for your engine.',
            content: 'API classifications are important indicators of oil quality and performance. Understanding these ratings helps you make informed decisions...',
            image: '/logo/engine_oil.jpeg',
            readTime: '8 min read'
        },
        {
            id: 6,
            title: 'MapLube Expands Distribution Network',
            category: 'company',
            date: '2023-12-10',
            author: 'MapLube News',
            excerpt: 'MapLube announces expansion of its distribution network to serve more customers across India.',
            content: 'MapLube is proud to announce the expansion of our distribution network. This expansion will improve accessibility and service for our customers...',
            image: '/logo/product.jpeg',
            readTime: '4 min read'
        }
    ];

    const categories = [
        { id: 'all', name: 'All Posts' },
        { id: 'maintenance', name: 'Maintenance Tips' },
        { id: 'industry', name: 'Industry News' },
        { id: 'company', name: 'Company Updates' },
        { id: 'education', name: 'Educational' }
    ];

    const getFilteredPosts = () => {
        if (activeCategory === 'all') {
            return blogPosts;
        }
        return blogPosts.filter(post => post.category === activeCategory);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="blog">
            {/* Hero Section */}
            <section className="blog-hero">
                <div className="container">
                    <div className="blog-hero-content">
                        <h1>MapLube Blog</h1>
                        <p>Stay updated with the latest industry insights, maintenance tips, and company news</p>
                    </div>
                </div>
            </section>

            {/* Category Filter */}
            <section className="category-filter">
                <div className="container">
                    <div className="filter-buttons">
                        {categories.map(category => (
                            <button
                                key={category.id}
                                className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
                                onClick={() => setActiveCategory(category.id)}
                            >
                                {category.name}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Blog Posts */}
            <section className="blog-posts">
                <div className="container">
                    <div className="posts-grid">
                        {getFilteredPosts().map(post => (
                            <article key={post.id} className="blog-card">
                                <div className="blog-image">
                                    <img src={post.image} alt={post.title} />
                                    <div className="blog-category">{post.category}</div>
                                </div>
                                <div className="blog-content">
                                    <div className="blog-meta">
                                        <span className="blog-date">{formatDate(post.date)}</span>
                                        <span className="blog-author">by {post.author}</span>
                                        <span className="blog-read-time">{post.readTime}</span>
                                    </div>
                                    <h2 className="blog-title">{post.title}</h2>
                                    <p className="blog-excerpt">{post.excerpt}</p>
                                    <button className="btn btn-outline">Read More</button>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            {/* Featured Post */}
            <section className="featured-post">
                <div className="container">
                    <div className="featured-content">
                        <div className="featured-text">
                            <span className="featured-label">Featured Article</span>
                            <h2>The Complete Guide to Engine Oil Maintenance</h2>
                            <p>Comprehensive guide covering everything you need to know about engine oil maintenance, from selection to change intervals and best practices for optimal engine performance.</p>
                            <div className="featured-meta">
                                <span>By MapLube Technical Team</span>
                                <span>10 min read</span>
                                <span>January 20, 2024</span>
                            </div>
                            <button className="btn btn-primary">Read Full Article</button>
                        </div>
                        <div className="featured-image">
                            <img src="/logo/original_logo.jpeg" alt="Featured Article" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Newsletter */}
            <section className="newsletter">
                <div className="container">
                    <div className="newsletter-content">
                        <h2>Stay Updated</h2>
                        <p>Subscribe to our newsletter for the latest industry insights, maintenance tips, and company updates.</p>
                        <form className="newsletter-form">
                            <input
                                type="email"
                                placeholder="Enter your email address"
                                className="newsletter-input"
                            />
                            <button type="submit" className="btn btn-primary">Subscribe</button>
                        </form>
                    </div>
                </div>
            </section>

            {/* Popular Topics */}
            <section className="popular-topics">
                <div className="container">
                    <h2>Popular Topics</h2>
                    <div className="topics-grid">
                        <div className="topic-card">
                            <div className="topic-icon">🔧</div>
                            <h3>Engine Maintenance</h3>
                            <p>Tips and guides for proper engine care and maintenance</p>
                        </div>
                        <div className="topic-card">
                            <div className="topic-icon">⚡</div>
                            <h3>Performance</h3>
                            <p>How to optimize your vehicle's performance with the right lubricants</p>
                        </div>
                        <div className="topic-card">
                            <div className="topic-icon">🌱</div>
                            <h3>Sustainability</h3>
                            <p>Eco-friendly lubricant solutions and environmental impact</p>
                        </div>
                        <div className="topic-card">
                            <div className="topic-icon">📊</div>
                            <h3>Industry Trends</h3>
                            <p>Latest developments and trends in the lubricant industry</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Blog; 